





























































































import { Prop, Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import { FormItem, Input, Option, Radio, RadioGroup, Select } from 'element-ui';
import { convertCustomerLocationFields } from '@/types/graphql/converter';
import {
  CustomerLocationFields,
  CustomerLocationInput
} from '@/types/graphql/schemaTypes';
import countries from '@/mixins/countryOptions';
import rules from '@/rules/rules';
import get from 'lodash/get';

@Component({
  components: {
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-radio': Radio,
    'el-radio-group': RadioGroup,
    'el-select': Select
  }
})
export default class LocationUpsert extends Mixins(countries) {
  @Prop({ type: Object }) customerLocation?: CustomerLocationInput | null;

  private customerLocationInput: CustomerLocationInput =
    convertCustomerLocationFields({} as CustomerLocationFields);

  private rules = rules;

  created() {
    if (this.customerLocation) {
      this.customerLocationInput = { ...this.customerLocation };
    }
  }

  get isAddressValid() {
    return get(this.customerLocation, 'gmapsData.placeId', null);
  }

  @Watch('customerLocationInput', { deep: true })
  private emitData(customerLocationInput: CustomerLocationInput) {
    this.$emit('input', customerLocationInput);
  }
}
